export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f79893368c94e57072367250e049ce6e422b62cba&name=fetchTypeahead!'